/** Big statement after the showreel — one entry per line */
export const statementLines = ['Most brands chase attention.', 'We build meaning.'];
